import { render, staticRenderFns } from "./StartRescue.vue?vue&type=template&id=4caaa057&"
import script from "./StartRescue.vue?vue&type=script&lang=js&"
export * from "./StartRescue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports